import { ITranslationTable } from 'src/app/core/contracts';
import { default as translationTable } from 'src/assets/i18n/en.json';
import { ITranslationKeys } from './types';

replaceTranslationsWithKeys(translationTable as ITranslationTable);
export const TranslationKeys = translationTable as unknown as ITranslationKeys;

/**
 *
 * @param item the translation table imported from a json file. e.g: import { default as translationTable } from "i18n/en.json")
 * @param namespace optional. generated in the recursion
 * @description takes a translation table object and replaces its translation values with keys
 */
function replaceTranslationsWithKeys(item: ITranslationTable, namespace?: string) {
  for (const property in item) {
    const key = (namespace ? namespace + '.' : '') + property;
    if (typeof item[property] === 'object') {
      replaceTranslationsWithKeys(item[property], key);
    } else if (typeof item[property] === 'string') {
      item[property] = key;
    }
  }
}
